import { render } from "./RecentActivity.vue?vue&type=template&id=04bab546&scoped=true"
import script from "./RecentActivity.vue?vue&type=script&lang=js"
export * from "./RecentActivity.vue?vue&type=script&lang=js"

import "./RecentActivity.vue?vue&type=style&index=0&id=04bab546&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bab546"]])

export default __exports__